import { PropsWithChildren, useRef } from 'react';

import { useIsFocused } from '@react-navigation/native';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { useModalFocusTrap } from 'hooks/accessibility/use-modal-focus-trap';

type PaymentModalFocusTrapProps = PropsWithChildren<{
  label: string;
}>;

export function PaymentModalFocusTrap({ children, label }: PaymentModalFocusTrapProps) {
  const isClosingRef = useRef(false);
  const isFocused = useIsFocused();
  const { modalRef, getModalA11yProps } = useModalFocusTrap({
    active: isFocused,
    label,
    isClosingRef,
  });

  return (
    <Box ref={modalRef} style={styles.wrapper} {...getModalA11yProps({ nativeRole: 'none' })}>
      {children}
    </Box>
  );
}

const styles = StyleSheet.create({
  wrapper: { flex: 1 },
});
